export default [
  {
    name: 'index', // 和pages下的目录名称一样
    title: '索引页面'
  }, {
    name: 'emptyPage',
    title: '空页面--iframe默认值专用'
  }, {
    name: 'coreSupplierApplyList',
    title: '核心供应商申请'
  }, {
    name: 'authSupplierApplyList',
    title: '认证供应商申请'
  }, {
    name: 'authSupplierApplyView',
    title: '认证供应商申请'
  }, {
    name: 'authSupplierApply',
    title: '认证供应商申请'
  }, {
    name: 'tagManage',
    title: '标签管理'
  }, {
    name: 'busioppsNumber',
    title: '商机次数'
  }, {
    name: 'qualifyApproveList',
    title: '资质审核'
  }, {
    name: 'platformQualificationView',
    title: '运营平台资质查看'
  }, {
    name: 'platformQualification',
    title: '运营平台资质'
  }, {
    name: 'productApprove',
    title: '运营产品审核'
  }, {
    name: 'enterpriseAuthService',
    title: '企业服务授权'
  }, {
    name: 'recommendedList',
    title: '智慧寻源推荐日志'
  }, {
    name: 'recommendedSupplier',
    title: '智慧寻源推荐日志'
  }, {
    name: 'platformOpportunity',
    title: '平台商机发现'
  }, {
    name: 'operationMessageList',
    title: '运营消息列表'
  }, {
    name: 'operationMessage',
    title: '运营消息'
  }
]



// WEBPACK FOOTER //
// ./src/configs/views.js